import styled from "styled-components";
import { V3Caption } from "../Typography";

export const OpenSettingsWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 18px;

    ${V3Caption} {
        color:  ${({ theme }) => theme.v3.colors.grey48};
    }

    > div {
        display: inline-flex;
        
        &:first-child {
            margin-right: 8px;
        }
    }
`;